import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=7da8da70&scoped=true"
import script from "./Contact.vue.js?vue&type=script&lang=js&external"
export * from "./Contact.vue.js?vue&type=script&lang=js&external"
import style0 from "./Contact.vue?vue&type=style&index=0&id=7da8da70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da8da70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
